import { SoftwareFeaturePage } from './SoftwareFeaturePage';

export function AiInterviewsPage() {
  return (
    <SoftwareFeaturePage content={{
      eyebrow: 'Software — AI Interviews',
      title: 'Screen 50 candidates without one phone call.',
      subtitle: 'Structured AI video & voice interviews at any scale, in any language.',
      description: 'GoGrabJob conducts structured, rubric-driven interviews on your behalf — video or voice — and returns scored transcripts so your team focuses only on the people worth a conversation.',
      heroBg: 'linear-gradient(150deg, #EFF6FF 0%, #DBEAFE 35%, #EFF6FF 65%, #E0F2FE 100%)',
      accentText: 'text-blue-600',
      stats: [
        { value: '50×', label: 'Candidates screened per hour' },
        { value: 'Video+Voice', label: 'Interview modalities' },
        { value: '12+', label: 'Languages supported' },
        { value: 'Auto', label: 'Transcription & scoring' },
      ],
      sections: [
        {
          heading: 'Interview Delivery',
          bullets: [
            'Async video or voice — candidates complete on their own schedule',
            'Structured question sets aligned to your JD and rubric',
            'Timed responses with configurable retry limits',
            'Mobile-friendly — no app install required',
            'Proctoring signals: tab-switch, gaze, and audio flags',
            'Instant candidate confirmation and reminder emails',
          ],
        },
        {
          heading: 'AI Evaluation',
          bullets: [
            'Full transcript generated per response',
            'AI score per question against the defined rubric',
            'Tone, confidence, and communication quality signals',
            'Multilingual support — EN, HI, Hinglish, and more',
            'Comparative scoring across all candidates for a role',
            'Recruiter override on any AI score with notes',
          ],
        },
        {
          heading: 'Evidence & Handoff',
          bullets: [
            'Shareable interview summary card for hiring managers',
            'Clip highlights — bookmark best answer moments',
            'Evidence exported to candidate profile automatically',
            'Audit-ready — every session timestamped and stored',
          ],
        },
      ],
    }} />
  );
}
